import { ArticleModel } from "../archive/article.model";
import { TransferStoreWorkshopModel } from "./transfer-store-workshop.model";

export class TransferStoreWorkshopDetailModel {
  transferStoreWorkshopDetailId: number = 0;
  transferStoreWorkshopId: number = 0;
  transferStoreWorkshop: TransferStoreWorkshopModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  storeId: number = 0;
  quantity: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}